var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 14",
    enableBackground: "new 0 0 42 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M0 0h20v6H0zM22 0h20v6H22zM0 8h20v6H0zM22 8h20v6H22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaronIcon);
export default __webpack_public_path__ + "static/media/baron_icon.308ecd34c467928255e42e45e17b9b18.svg";
export { ForwardRef as ReactComponent };